module.exports = React.addons.createFragment;


//////////////////
// WEBPACK FOOTER
// external "React.addons.createFragment"
// module id = 909
// module chunks = 0